import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext";
import TestataAdmin from "./partials/TestataAdmin";
import Footer from "./partials/Footer";

function Annuncio() {
  const { userData } = useContext(UserContext);
  const { id: annuncioId } = useParams();
  const [annuncio, setAnnuncio] = useState(null);
  const [allegati, setAllegati] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [error, setError] = useState(null);  
  const [selectedFile, setSelectedFile] = useState(null); 
  const [showSuccessMessage, setShowSuccessMessage] = useState(false); 
  const [showConfirmationModal, setShowConfirmationModal] = useState(false); // Stato per il modale dell'annuncio
  const [showConfirmationModalAllegato, setShowConfirmationModalAllegato] = useState(false); // Stato per il modale dell'allegato
  const [annunciToDelete, setAnnunciToDelete] = useState(null);
  const [allegatoToDelete, setAllegatoToDelete] = useState(null);
  const navigate = useNavigate();
  const [textAreaValue, setTextAreaValue] = useState("");
    const maxChars = 1000;
  // Definizione della funzione fetchCliente FUORI da useEffect
  const fetchAnnuncio = async () => { 
    try {
      // console.log('annuncioId in useEffect:', annuncioId);
      const token = localStorage.getItem("token");
      const response = await fetch(
        `/api/annuncio/${annuncioId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        data.forfait = data.forfait === true;
        setAnnuncio(data);
        setFormData(data); // Inizializza formData con i dati del cliente
      } else {
        throw new Error("Errore nel recupero dell'anagrafica");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchAnnuncio();
  }, [annuncioId]);

  const fetchAllegati = async () => { 
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `/api/allegati/${annuncioId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        setAllegati(data);
      } else {
        throw new Error("Errore nel recupero degli Allegati");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  useEffect(() => {
    fetchAllegati();
  }, [annuncioId]);

  const province = [
    { sigla: 'AG', nome: 'Agrigento' },
    { sigla: 'AL', nome: 'Alessandria' },
    { sigla: 'AN', nome: 'Ancona' },
    { sigla: 'AO', nome: 'Aosta' },
    { sigla: 'AR', nome: 'Arezzo' },
    { sigla: 'AP', nome: 'Ascoli Piceno' },
    { sigla: 'AT', nome: 'Asti' },
    { sigla: 'AV', nome: 'Avellino' },
    { sigla: 'BA', nome: 'Bari' },
    { sigla: 'BT', nome: 'Barletta-Andria-Trani' },
    { sigla: 'BL', nome: 'Belluno' },
    { sigla: 'BN', nome: 'Benevento' },
    { sigla: 'BG', nome: 'Bergamo' },
    { sigla: 'BI', nome: 'Biella' },
    { sigla: 'BO', nome: 'Bologna' },
    { sigla: 'BZ', nome: 'Bolzano' },
    { sigla: 'BS', nome: 'Brescia' },
    { sigla: 'BR', nome: 'Brindisi' },
    { sigla: 'CA', nome: 'Cagliari' },
    { sigla: 'CL', nome: 'Caltanissetta' },
    { sigla: 'CB', nome: 'Campobasso' },
    { sigla: 'CI', nome: 'Carbonia-Iglesias' },
    { sigla: 'CE', nome: 'Caserta' },
    { sigla: 'CT', nome: 'Catania' },
    { sigla: 'CZ', nome: 'Catanzaro' },
    { sigla: 'CH', nome: 'Chieti' },
    { sigla: 'CO', nome: 'Como' },
    { sigla: 'CS', nome: 'Cosenza' },
    { sigla: 'CR', nome: 'Cremona' },
    { sigla: 'KR', nome: 'Crotone' },
    { sigla: 'CN', nome: 'Cuneo' },
    { sigla: 'EN', nome: 'Enna' },
    { sigla: 'FM', nome: 'Fermo' },
    { sigla: 'FE', nome: 'Ferrara' },
    { sigla: 'FI', nome: 'Firenze' },
    { sigla: 'FG', nome: 'Foggia' },
    { sigla: 'FC', nome: 'Forlì-Cesena' },
    { sigla: 'FR', nome: 'Frosinone' },
    { sigla: 'GE', nome: 'Genova' },
    { sigla: 'GO', nome: 'Gorizia' },
    { sigla: 'GR', nome: 'Grosseto' },
    { sigla: 'IM', nome: 'Imperia' },
    { sigla: 'IS', nome: 'Isernia' },
    { sigla: 'SP', nome: 'La Spezia' },
    { sigla: 'AQ', nome: "L'Aquila" },
    { sigla: 'LT', nome: 'Latina' },
    { sigla: 'LE', nome: 'Lecce' },
    { sigla: 'LC', nome: 'Lecco' },
    { sigla: 'LI', nome: 'Livorno' },
    { sigla: 'LO', nome: 'Lodi' },
    { sigla: 'LU', nome: 'Lucca' },
    { sigla: 'MC', nome: 'Macerata' },
    { sigla: 'MN', nome: 'Mantova' },
    { sigla: 'MS', nome: 'Massa-Carrara' },
    { sigla: 'MT', nome: 'Matera' },
    { sigla: 'ME', nome: 'Messina' },
    { sigla: 'MI', nome: 'Milano' },
    { sigla: 'MO', nome: 'Modena' },
    { sigla: 'MB', nome: 'Monza e della Brianza' },
    { sigla: 'NA', nome: 'Napoli' },
    { sigla: 'NO', nome: 'Novara' },
    { sigla: 'NU', nome: 'Nuoro' },
    { sigla: 'OG', nome: 'Ogliastra' },
    { sigla: 'OT', nome: 'Olbia-Tempio' },
    { sigla: 'OR', nome: 'Oristano' },
    { sigla: 'PD', nome: 'Padova' },
    { sigla: 'PA', nome: 'Palermo' },
    { sigla: 'PR', nome: 'Parma' },
    { sigla: 'PV', nome: 'Pavia' },
    { sigla: 'PG', nome: 'Perugia' },
    { sigla: 'PU', nome: 'Pesaro e Urbino' },
    { sigla: 'PE', nome: 'Pescara' },
    { sigla: 'PC', nome: 'Piacenza' },
    { sigla: 'PI', nome: 'Pisa' },
    { sigla: 'PT', nome: 'Pistoia' },
    { sigla: 'PN', nome: 'Pordenone' },
    { sigla: 'PZ', nome: 'Potenza' },
    { sigla: 'PO', nome: 'Prato' },
    { sigla: 'RG', nome: 'Ragusa' },
    { sigla: 'RA', nome: 'Ravenna' },
    { sigla: 'RC', nome: 'Reggio Calabria' },
    { sigla: 'RE', nome: 'Reggio Emilia' },
    { sigla: 'RI', nome: 'Rieti' },
    { sigla: 'RN', nome: 'Rimini' },
    { sigla: 'RM', nome: 'Roma' },
    { sigla: 'RO', nome: 'Rovigo' },
    { sigla: 'SA', nome: 'Salerno' },
    { sigla: 'VS', nome: 'Medio Campidano' },
    { sigla: 'SS', nome: 'Sassari' },
    { sigla: 'SV', nome: 'Savona' },
    { sigla: 'SI', nome: 'Siena' },
    { sigla: 'SR', nome: 'Siracusa' },
    { sigla: 'SO', nome: 'Sondrio' },
    { sigla: 'TA', nome: 'Taranto' },
    { sigla: 'TE', nome: 'Teramo' },
    { sigla: 'TR', nome: 'Terni' },
    { sigla: 'TO', nome: 'Torino' },
    { sigla: 'TP', nome: 'Trapani' },
    { sigla: 'TN', nome: 'Trento' },
    { sigla: 'TV', nome: 'Treviso' },
    { sigla: 'TS', nome: 'Trieste' },
    { sigla: 'UD', nome: 'Udine' },
    { sigla: 'VA', nome: 'Varese' },
    { sigla: 'VE', nome: 'Venezia' },
    { sigla: 'VB', nome: 'Verbano-Cusio-Ossola' },
    { sigla: 'VC', nome: 'Vercelli' },
    { sigla: 'VR', nome: 'Verona' },
    { sigla: 'VV', nome: 'Vibo Valentia' },
    { sigla: 'VI', nome: 'Vicenza' },
    { sigla: 'VT', nome: 'Viterbo' },
  ];

  const regioni = [
    { sigla: 'Abruzzo', nome: 'Abruzzo' },
    { sigla: 'Basilicata', nome: 'Basilicata' },
    { sigla: 'Calabria', nome: 'Calabria' },
    { sigla: 'Campania', nome: 'Campania' },
    { sigla: 'Emilia Romagna', nome: 'Emilia Romagna' },
    { sigla: 'Friuli Venezia Giulia,', nome: 'Friuli Venezia Giulia,' },
    { sigla: 'Lazio', nome: 'Lazio' },
    { sigla: 'Liguria', nome: 'Liguria' },
    { sigla: 'Lombardia', nome: 'Lombardia' },
    { sigla: 'Marche', nome: 'Marche' },
    { sigla: 'Molise ', nome: 'Molise ' },
    { sigla: 'Piemonte', nome: 'Piemonte' },
    { sigla: 'Puglia', nome: 'Puglia' },
    { sigla: 'Sardegna', nome: 'Sardegna' },
    { sigla: 'Sicilia', nome: 'Sicilia' },
    { sigla: 'Toscana', nome: 'Toscana' },
    { sigla: 'Trentino Alto Adige', nome: 'Trentino Alto Adige' },
    { sigla: 'Umbria', nome: 'Umbria' },
    { sigla: 'Veneto', nome: 'Veneto' },
    { sigla: 'Valle d\'Aosta', nome: 'Valle d\'Aosta' },
  ];

  const [tipo, setTipo] = useState('');
  const [nome, setNome] = useState('');
  const [cognome, setCognome] = useState('');
  const [formData, setFormData] = useState({
    id_utente: userData ? userData.id : "",
    nome: "",
    cognome: "",
    tipo: "",
    filename: "",
  });
  useState(false);

  const dataNascita = formData.nato; 
  const data = new Date(dataNascita);
  // Formatta la data nel formato YYYY-MM-DD
  const anno = data.getFullYear();
  const mese = (data.getMonth() + 1).toString().padStart(2, '0'); // +1 perché i mesi partono da 0
  const giorno = data.getDate().toString().padStart(2, '0');
  const dataNato = `${anno}-${mese}-${giorno}`;

  const dataDecesso = formData.decesso; 
  const dataM = new Date(dataDecesso);
  // Formatta la data nel formato YYYY-MM-DD
  const annoM = dataM.getFullYear();
  const meseM = (dataM.getMonth() + 1).toString().padStart(2, '0'); // +1 perché i mesi partono da 0
  const giornoM = dataM.getDate().toString().padStart(2, '0');
  const dataMorte = `${annoM}-${meseM}-${giornoM}`;
  useEffect(() => {
    // Imposta il valore predefinito di cosa solo se tipo è null o undefined
    if (!tipo) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        cosa: "Necrologio",
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        cosa: tipo,
      }));
    }
  }, [tipo]); // Dipendenza da tipo

  const handleFileChange = (e) => {
    // const { name, value } = e.target; // Ottieni il valore del radio button selezionato
    // setFormData((prevFormData) => ({
    //   ...prevFormData,
    //   [name]: value, // Aggiorna lo stato con il valore del radio button
    // }));
    // setSelectedFile(e.target.files[0]); // Aggiorna lo stato con il file selezionato
    const file = e.target.files[0]; // Ottieni il file selezionato
    if (file) {
      setSelectedFile(file); // Aggiorna lo stato con il file
    }
  };
  
  const handleChange = (e) => {
  const { name, value } = e.target;

  // Controlla se l'input è la textarea "testo"
  if (name === "testo") {
    if (value.length <= maxChars) {
      setTextAreaValue(value);

      // Aggiorna formData solo se la lunghezza è valida
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  } else {
    // Aggiorna gli altri campi di formData
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  }
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
    
  //   try {
  //     const token = localStorage.getItem('token');
  //     const formDataToSend = new FormData();
  //     for (const key in formData) {
  //       formDataToSend.append(key, formData[key]);
  //     }
  //     if (selectedFile) { 
  //       formDataToSend.append('file', selectedFile);
  //     }
      
  //     const response = await fetch(`/api/annuncio/${annuncioId}`, {
  //       method: 'PATCH',
  //       headers: {
  //         'Authorization': `Bearer ${token}`
  //       },
  //       credentials: 'include',
  //       body: formDataToSend
  //     });

  //     if (response.ok) {
  //       const data = await response.json();
  //       setShowSuccessMessage(true);
  //       // Nascondi il messaggio dopo un breve ritardo (opzionale)
  //       setTimeout(() => {
  //         setShowSuccessMessage(false);
  //       }, 3000); // Nascondi dopo 3 secondi
  //       setAnnuncio(data);
  //       setFormData(data); // Inizializza formData con i dati del cliente
  //       setEditMode(false);
  //     } else {
  //       const errorData = await response.json();
  //       alert(errorData.error || 'Errore durante il caricamento del documento');
  //     }
  //   } catch (err) {
  //     console.error('Errore durante il caricamento:', err);
  //     alert('Si \u00e8 verificato un errore durante il caricamento. Probabilmente il tipo di file non è consentito o le dimensioni superano 1 Mb. massimi consentiti.');
  //   }    
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      const formDataToSend = new FormData();

      // Aggiungi i dati generici del modulo
      for (const key in formData) {
        if (formData[key] !== undefined && formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      }

      // Aggiungi il file solo se selezionato
      if (selectedFile) {
        formDataToSend.append('file', selectedFile);
      }

      const response = await fetch(`/api/annuncio/${annuncioId}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
        body: formDataToSend,
      });

      if (response.ok) {
        const data = await response.json();
        setShowSuccessMessage(true);

        // Nascondi il messaggio dopo 3 secondi
        setTimeout(() => {
          setShowSuccessMessage(false);
        }, 3000);

        // Aggiorna i dati nello stato
        setAnnuncio(data);
        setFormData(data);
        setEditMode(false);
      } else {
        const errorData = await response.json();
        alert(errorData.error || 'Errore durante il caricamento del documento');
      }
    } catch (err) {
      console.error('Errore durante il caricamento:', err);
      alert(
        'Si è verificato un errore durante il caricamento. Probabilmente il tipo di file non è consentito o le dimensioni superano 1 Mb.'
      );
    }
  };
  
  const handleDeleteAnnuncio = (annuncioId) => {
    setAnnunciToDelete(annuncioId);
    setShowConfirmationModal(true);
  };

  const confirmDeleteAnnuncio = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/annuncio/${annunciToDelete}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
      });

      if (response.ok) {
        // Reindirizza l'utente alla dashboard
        navigate('/dashboard'); 
      } else {
        // Gestisci l'errore di eliminazione
        const errorData = await response.json(); 
        setError(errorData.error || 'Errore durante l\'eliminazione dell\'annuncio');
      }
    } catch (err) {
      console.error('Errore:', err);
    setError('Errore durante l\'eliminazione dell\'annuncio'); // Gestisci l'errore di rete
  } finally {
    setShowConfirmationModal(false);
    setAnnunciToDelete(null);
  }
};

  const handleDeleteAllegato = (allegatoId) => {
    setAllegatoToDelete(allegatoId);
    setShowConfirmationModalAllegato(true);
  };

  const confirmDeleteAllegato = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/allegato/${allegatoToDelete}`, { 
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        credentials: 'include',
      });

      if (response.ok) {
        // Aggiorna la lista degli allegati dopo l'eliminazione
        setAllegati(allegati.filter(allegato => allegato._id !== allegatoToDelete));
      } else {
        throw new Error('Errore durante l\'eliminazione dell\'allegato');
      }
    } catch (err) {
      console.error('Errore:', err);
      // Gestisci l'errore (ad esempio, mostra un messaggio all'utente)
    } finally {
      setShowConfirmationModalAllegato(false);
      setAllegatoToDelete(null);
    }
  };
  return (
    <>
      <section className="main_content dashboard_part">
        <div className='className="container-fluid g-0'>            
            <TestataAdmin userData={userData} />
        </div>
        <div className="main_content_iner dashboard_part">
          <div className="container-fluid plr_30 body_white_bg pt_30">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="white_box_tittle list_header">
                  <h4><a href="/amministratore/dashboard"><i className="ti-arrow-circle-left" style={{fontSize: '0.8rem'}}></i> Indietro</a> &nbsp; | &nbsp; Dettaglio Annuncio</h4>
                  <button  className="btn btn-sm btn-danger"  onClick={() => handleDeleteAnnuncio(annuncioId)} title="Elimina questo annuncio"><i className='ti-trash'></i> Elimina questo annuncio</button>
                  {!editMode && ( // Mostra il pulsante "Modifica" solo se non sei in modalità modifica
                    <button className="btn btn-outline-warning btn-sm" onClick={() => setEditMode(true)}>
                      Modifica
                    </button>
                  )}
                </div>
                {error && <p className="error-message">{error}</p>}
                {annuncio ? (
                  <form onSubmit={handleSubmit}>
                    <div className="col-12 mb_30">
                      <div className="row">
                        <div className="form-group col-md-2 col-sm-12 mb_20">
                            <label htmlFor="tipo">Codice Fiscale:</label>
                            {/* <input
                                type="text"
                                className="form-control"
                                id="tipo"
                                name="tipo"
                                value={formData.tipo}
                                onChange={handleChange}
                                disabled={!editMode} // Disabilita il campo se non sei in modalità modifica
                            /> */}
                            <br /> <b>{formData.codfisc}</b>
                        </div>
                        <div className="form-group col-md-2 cols-sm-6 mb_30">
                            <label htmlFor="codfisc">
                                Di anni <b className="text text-danger">*</b>:
                            </label>
                            <input type="number" className="form-control" id="age" name="age" value={formData.age} onChange={handleChange} disabled={!editMode} />
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="nome">Nome:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="nome"
                                name="nome"
                                value={formData.nome}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="cognome">Cognome:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cognome"
                                name="cognome"
                                value={formData.cognome}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="nato">Nata/o il:</label>
                            <input
                                type="date" 
                                className="form-control"
                                id="nato"
                                name="nato"
                                value={dataNato}
                                onChange={handleChange}
                                disabled={!editMode}  
                            />
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="natoA">Nata/o a:</label>
                            <input
                                type="text" 
                                className="form-control"
                                id="natoA"
                                name="natoA"
                                value={formData.natoA}
                                onChange={handleChange}
                                disabled={!editMode}  
                            />
                        </div> 
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="decesso">Deceduta/o il:</label>
                            <input
                                type="date" 
                                className="form-control"
                                id="decesso"
                                name="decesso"
                                value={dataMorte}
                                onChange={handleChange}
                                disabled={!editMode}  
                            />
                        </div> 
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="mortoA">Deceduta/o a:</label>
                            <input
                                type="text" 
                                className="form-control"
                                id="mortoA"
                                name="mortoA"
                                value={formData.mortoA}
                                onChange={handleChange}
                                disabled={!editMode}  
                            />
                        </div>                      

                        <div className="form-group col-md-4 col-sm-12 mb_20">
                          <label htmlFor="coniuge">Nominativo del Coniuge:</label>
                          <input
                            type="text" 
                            className="form-control"
                            id="coniuge"  
                            name="coniuge"
                            value={formData.coniuge}  
                            onChange={handleChange}
                            disabled={!editMode}  
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                            <label htmlFor="comune">Comune:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="comune"
                                name="comune"
                                value={formData.comune}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                        <div className="form-group col-md-4 col-sm-12 mb_20">
                          <label htmlFor="regione">Regione:</label>
                          <select
                            className="form-select form-control"
                            id="regione"
                            name="regione"
                            value={formData.regione} // Imposta il valore in maiuscolo
                            onChange={handleChange}
                            disabled={!editMode}
                          >
                          {regioni.map(regione => (
                            <option key={regione.sigla} value={regione.sigla}>
                              {regione.nome.charAt(0) + regione.nome.slice(1)}
                            </option>
                          ))}
                          </select>
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                          <label htmlFor="prov">Prov:</label>
                          <select
                            className="form-select form-control"
                            id="prov"
                            name="prov"
                            value={formData.prov} // Imposta il valore in maiuscolo
                            onChange={handleChange}
                            disabled={!editMode}
                          >
                          {province.map(prov => (
                            <option key={prov.sigla} value={prov.sigla.toUpperCase()}>
                              {prov.nome.charAt(0).toUpperCase() + prov.nome.slice(1)}
                            </option>
                          ))}
                          </select>
                        </div>
                        <div className="form-group col-md-2 col-sm-6 mb_20">
                            <label htmlFor="cap">CAP:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="cap"
                                name="cap"
                                value={formData.cap}
                                onChange={handleChange}
                                disabled={!editMode}
                            />
                        </div>
                      </div>
                      <div className="row justify-content-center">
                        <div className="form-group col-md-6 col-sm-12 mb_20">
                          <label htmlFor="funerale">
                            Data e luogo del funerale:
                          </label>
                          <textarea 
                            className="form-control" 
                            id="funerale" 
                            name="funerale" 
                            value={formData.funerale} 
                            onChange={handleChange} 
                            disabled={!editMode}                            
                          />
                        </div>
                        <div className="form-group col-md-6 col-sm-12 mb_20">
                          <label htmlFor="cimitero">
                            Ubicazione del Cimitero:
                          </label>
                          <textarea 
                            className="form-control" 
                            id="cimitero" 
                            name="cimitero" 
                            value={formData.cimitero} 
                            onChange={handleChange} 
                            disabled={!editMode}                            
                          />
                        </div>
                      </div>
                      <div className="row justify-content-center"> {/* Aggiunto row per centrare */}
                        <div className="form-group col-sm-12 col-md-8 col-lg-6 mb_30"> 
                          <label htmlFor="testo">
                            Testo libero <i className="text text-danger">(max 1000 caratteri)</i>:
                          </label>
                          <textarea 
                            className="form-control" 
                            id="testo" 
                            name="testo" 
                            value={textAreaValue} 
                            onChange={handleChange} 
                            rows="6" // Aggiunto attributo rows per l'altezza
                            maxLength={maxChars} 
                            disabled={!editMode}   
                          />
                          <div>
                            Caratteri inseriti: {textAreaValue.length} / {maxChars}
                          </div>
                          <div>
                            Caratteri rimanenti: {maxChars - textAreaValue.length}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-12 mb_20">
                            {editMode ? (
                              <div>
                                {/* Modulo di caricamento dell'immagine */}
                                <div className='row mb_20'>
                                  <div className='col-lg-4 col-md-8 col-sm-12 col-xs-10 alert alert-warning'>
                                    <h3>ATTENZIONE:</h3>
                                    Non sono consentiti file non rispondenti ai seguenti requisiti:
                                    <ul>
                                      <li> &nbsp; a) Dimensioni: <b>non</b> superiori a <b>1 MegaBytes</b></li>
                                      <li> &nbsp; b) Formato: <b>.JPG/.JPEG</b> o <b>.PNG</b></li>
                                      <li> &nbsp; c) Dimensioni massime: <b>1920 x 1280 px</b></li>
                                    </ul>
                                  </div>
                                  {formData.img ? (
                                    <div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 mb-3">
                                      <img 
                                      src={`/necrologi/${formData.id_utente}/${formData.img}`} 
                                      alt={`${formData.nome} ${formData.cognome}`} 
                                      onError={(e) => { e.target.src = '/necrologi/vuoto.jpg'; }}
                                      className="img-fluid"
                                    />
                                    </div>
                                  ) : (<div className="col-lg-2 col-md-2 col-sm-4 col-xs-12 mb_20"></div>)}
                                  <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12 mb_20">
                                    <div className="input-group mb-3">
                                      <label className="form-label" htmlFor="file">Scegli il file dal tuo device
                                        <input type="file" className="form-control" name="file" id="file" onChange={handleFileChange} disabled={!editMode} />
                                        
                                      </label>
                                    </div>
                                  </div> 
                                </div>
                              </div>
                              ) : (
                              
                              <div className="row">
                                {/* Immagine esistente */}                                
                                <div className="col-md-3 col-sm-2"></div>
                                <div className="col-md-6 col-sm-8 col-xs-12 mb_20">
                                  <img 
                                    src={`/necrologi/${formData.id_utente}/${formData.img}`} 
                                    alt={`${formData.nome} ${formData.cognome}`} 
                                    onError={(e) => { e.target.src = '/necrologi/vuoto.jpg'; }}
                                    className="img-fluid"
                                  />
                                </div>
                              </div>
                            )}
                        </div>                      
                      
                        <div className="form-group col-md-8 cols-sm-12 mb_20" style={{textAlign: 'right'}}>
                            {showSuccessMessage && ( // Mostra il messaggio solo se showSuccessMessage è true
                                <div className="alert alert-success mt_20" role="alert">Dati aggiornati con successo!</div>
                            )}
                            {editMode && ( // Mostra il pulsante "Salva" solo se sei in modalità modifica
                                <button type="submit" className="btn btn-primary mt_20">
                                    Salva
                                </button>
                            )}
                        </div>
                      </div>
                    </div>
                      {/* Modale di conferma (Bootstrap 5) */}
                      <div className={`modal fade ${showConfirmationModal ? 'show' : ''}`} style={{ display: showConfirmationModal ? 'block' : 'none', backgroundColor: 'rgba(255, 255, 255, 1)' }} tabIndex="-1">
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Conferma eliminazione</h5>
                              <button type="button" className="btn-close" onClick={() => setShowConfirmationModal(false)} aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                              <p>Sei sicuro di voler eliminare questo annuncio?</p>
                            </div>
                            <div className="modal-footer">
                              <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmationModal(false)}>Annulla</button>
                              <button type="button" className="btn btn-danger" onClick={confirmDeleteAnnuncio}>Elimina questo Annuncio</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Fine Modale di conferma */}
                  </form>                  
                ) : (
                  <p>Caricamento in corso...</p>
                )}
              </div>

              {allegati.length > 0 && (
                <div className="col-lg-12">
                  <div className="row justify-content-center">
                    <h4 className="text text-center mt_30 mb_30">Partecipazioni & Ringraziamenti</h4>
                    {allegati.map(allegato => (
                      <div className="col-12 mb_30" key={allegato._id}> {/* Aggiungi la key qui */}
                        <div className="row">
                          <div className="col-md-4 col-sm-3"></div>
                          <div className="col-md-4 col-sm-6 col-xs-12 mb_30">
                            <img
                              src={`/necrologi/${allegato.id_utente}/${allegato.img}`}
                              alt="Allegato all'annuncio principale"
                              onError={(e) => { e.target.src = '/necrologi/vuoto.jpg';}}
                              className="img-fluid bordoChiaro"
                            />
                            <button className="btn btn-sm btn-danger" style={{ float: "right"}} onClick={() => handleDeleteAllegato(allegato._id)} title="Elimina questo allegato">
                              <i className='ti-trash'></i> Elimina questo allegato
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Modale di conferma (Bootstrap 5) */}
              <div className={`modal fade ${showConfirmationModalAllegato ? 'show' : ''}`} style={{ display: showConfirmationModalAllegato ? 'block' : 'none', backgroundColor: 'rgba(255, 255, 255, 1)' }} tabIndex="-1">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Conferma eliminazione</h5>
                      <button type="button" className="btn-close" onClick={() => showConfirmationModalAllegato(false)} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <p>Sei sicuro di voler eliminare questo allegato?</p>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowConfirmationModalAllegato(false)}>Annulla</button>
                      <button type="button" className="btn btn-danger" onClick={confirmDeleteAllegato}>Elimina</button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Fine Modale di conferma */}
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Annuncio;
